export const OAUTH_CALLBACK = "OAUTH_CALLBACK";
